import { useState } from "react"
import { useNavigate } from "react-router-dom"
import { MultiStepFlowContainer } from "../Components/MultiStepFlow"
import { selfInitiatedFlowSteps, selfInitiatedInitialValues } from "../Data/self-initiated-flow"
import api from "../services/api"
import { useAtom } from "jotai"
import { userAtom } from "../state"
import { sentryService } from "../services/sentry"

const PlanNewFlow = () => {
  const navigate = useNavigate()
  const [user] = useAtom(userAtom)
  const [error, setError] = useState(null)

  const steps = selfInitiatedFlowSteps(user)

  const handleComplete = async values => {
    setError(null)
    try {
      const organizationId = values.organization_id
        ?? (user?.organizations?.length === 1 ? user.organizations[0].id : null)

      const planResponse = await api.createPlan({
        name: values.plan_name,
        organization_id: organizationId,
        content: Object.keys(values)
          .filter(key => !['organization_id'].includes(key))
          .map(key => ({
            key,
            value: values[key] === "" ? "N/A" : values[key] ?? "N/A",
          })),
      })

      if (planResponse.data) {
        navigate(`/plan/${planResponse.data.token}/checklist`)
      }
    } catch (err) {
      sentryService.captureException(err)

      if (err.response?.status === 429) {
        setError({
          title: "Too many requests",
          description: "You've created too many plans in a short time. Please wait a moment and try again.",
        })
      } else {
        setError({
          title: "Failed to create plan",
          description: err.response?.data?.message || err.message || err.toString(),
        })
      }
    }
  }

  return (
    <MultiStepFlowContainer
      steps={steps}
      initialValues={selfInitiatedInitialValues}
      alwaysShowBackButton
      onComplete={handleComplete}
      fieldWidth="w-64 mx-auto"
      fieldContainerClassName="flex flex-col items-center"
      errors={error}
      stepProgressModifier={1}
    />
  )
}

export { PlanNewFlow }
